/**
 * Utilitários para manipulação de strings
 */

export class StringUtils {
  /**
   * Retorna o primeiro e o último nome como uma string única.
   * @param fullName Nome completo do usuário
   * @returns Ex: "Pablo Silva", "Ana", ""
   */
  public static getFirstAndLastName(fullName: string | null | undefined): string {
    if (!fullName) {
      return '';
    }

    const parts = fullName.trim().split(/\s+/);

    if (parts.length === 0) {
      return '';
    }

    if (parts.length === 1) {
      return parts[0]; // ex: "Ana"
    }

    return `${parts[0]} ${parts[parts.length - 1]}`; // ex: "Pablo Silva"
  }

  /**
   * Aplica máscara de telefone para números com 10 ou 11 dígitos.
   * Retorna string vazia se null, undefined ou inválido.
   *
   * @param phone string | null | undefined
   * @returns string formatada: (11) 99999-9999 ou (11) 3333-3333
   */
  public static formatPhoneNumber(phone: string | null | undefined): string {
    if (!phone) return '';

    const digitsOnly = phone.replace(/\D/g, '');

    if (digitsOnly.length === 10) {
      return digitsOnly.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else if (digitsOnly.length === 11) {
      return digitsOnly.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }

    return phone;
  }

  /**
   * Retorna as iniciais do primeiro e último nomes.
   * Ex: "Amanda Lobo Gomes" → "AG"
   */
  static getFirstAndLastInitials(fullName: string): string {
    if (!fullName) return '';

    const parts = fullName
      .trim()
      .split(/\s+/)
      .filter((p) => p.length > 0);

    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0][0].toUpperCase();

    const firstInitial = parts[0][0].toUpperCase();
    const lastInitial = parts[parts.length - 1][0].toUpperCase();

    return firstInitial + lastInitial;
  }

  /**
   * Valida se a string recebida está de acordo com a máscara PRC-9999/99999 ou EXP-9999/99999
   */
  static validateProcessoSPSPMask(value: any): boolean {
    if (!value) return false;
    const regex = /^(PRC|EXP)-\d{4}\/\d{5}$/;
    return regex.test(value);
  }

  static digitsOnly(value: string | undefined): string {
    if (!value) return '';
    return value.replace(/\D/g, '');
  }
}
